<template>
  <div class="flex w-full flex-col gap-6 p-6" v-if="pageEnabled">
    <nav class="pb-3" aria-label="Breadcrumb">
      <ol class="flex space-x-1 truncate text-xs md:space-x-4 md:text-sm">
        <li>
          <div>
            <router-link to="/" class="text-gray-400 hover:text-gray-400">
              <span v-html="$icons.home"></span>

              <span class="sr-only">Home</span>
            </router-link>
          </div>
        </li>
        <li v-for="(item, i) in breadcrumb" :key="i">
          <div class="flex items-center">
            <span class="text-gray-400" v-html="$icons.chevron_right"></span>

            <router-link
              :to="item.url"
              class="ml-1 text-xs font-medium text-gray-400 hover:text-gray-700 md:ml-4 md:text-sm"
            >
              {{ item.name }}
            </router-link>
          </div>
        </li>
      </ol>
    </nav>
    <div class="flex items-center justify-between">
      <div>
        <div class="flex items-center gap-4">
          <i v-html="$icons.edit_document"> </i>
          <h3 class="text-2xl font-bold">Pré-autorizações de operações L&S</h3>
        </div>
        <span class="text-sm text-gray-500 dark:text-gray-400">
          Deixe suas operações L&S pré autorizadas por um prazo determinado.
        </span>
      </div>
    </div>
    <div class="flex w-full flex-col gap-4">
      <div class="flex items-center justify-between">
        <div
          class="bg-ontick-graphite-500 ring-ontick-blue-800 relative flex h-10 items-center overflow-hidden rounded text-sm focus-within:ring-2"
        >
          <button
            class="absolute left-0 top-0 flex h-full items-center justify-center px-2 filter transition-all hover:brightness-125"
          >
            <i v-html="$icons.search"> </i>
          </button>
          <input type="text" class="border-0 bg-transparent pl-10" placeholder="Buscar" v-model="search" />
        </div>
        <router-link :to="{ name: 'Nova autorização Long & Short' }">
          <button
            class="bg-ontick-blue-600 dark:bg-ontick-blue-900 flex h-10 items-center gap-2 rounded px-4 text-sm font-semibold text-white shadow filter transition-all hover:brightness-110"
          >
            <i v-html="$icons.plus_sm"></i>
            <span> Nova autorização </span>
          </button>
        </router-link>
      </div>
      <auth-table-component :authorizations="filteredAuthorizations" :tableHead="tableHead" @reload="getData" />
    </div>

    <!-- <div
      v-else
      class="flex items-center justify-center py-16 text-2xl font-bold"
    >
      <p>Nenhuma autorização encontrada</p>
    </div> -->
    <ontick-modal-component :open="detailsModalIsActive" size="small" @close="detailsModalIsActive = false">
      <auth-details-component :authId="detailsId" />
    </ontick-modal-component>
  </div>
</template>

<script>
import ontickBrokerLogoComponent from "../../../shared/components/basic/ontick-broker-logo.component.vue";
import { mapGetters } from "vuex";
import OntickModalComponent from "../../../shared/components/basic/ontick-modal.component.vue";
import AuthDetailsComponent from "../components/auth-details.component.vue";
import event_bus from "../../../shared/utils/event_bus";
import AuthTableComponent from "../components/auth-table.component.vue";

export default {
  components: {
    ontickBrokerLogoComponent,
    OntickModalComponent,
    AuthDetailsComponent,
    AuthTableComponent,
  },

  data() {
    return {
      authorizations: [],
      detailsModalIsActive: false,
      detailsId: null,
      tableHead: [
        {
          label: "Status",
          visible: false,
        },
        {
          label: "ID",
          visible: true,
        },
        {
          label: "Conta",
          visible: true,
        },
        {
          label: "Parceiro",
          visible: true,
        },
        {
          label: "Estratégia",
          visible: true,
        },
        {
          label: "Analista",
          visible: true,
        },
        {
          label: "Máx. operações",
          visible: true,
        },
        {
          label: "Vol./operação",
          visible: true,
        },
        {
          label: "Data de aprovação",
          visible: true,
        },
      ],
      search: "",
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
    }),
    pageEnabled() {
      return this.getConfigs.side_menus.map((item) => item.menu_name).includes("Long & Short");
    },
    breadcrumb() {
      return [
        {
          name: "Long & Short",
          url: { name: "Long & Short" },
        },
        {
          name: this.routeName,
          url: { name: this.$route.name },
        },
      ];
    },
    routeName() {
      switch (this.$route.name) {
        case "Pré-autorização Long & Short":
          return "Pré-autorização";
        default:
          return this.$route.name;
      }
    },
    filteredAuthorizations() {
      return this.search.length
        ? this.authorizations.filter((item) => {
            return (
              item.strategy_name.toUpperCase().includes(this.search.toUpperCase()) ||
              String(item.aut_id).includes(this.search.toUpperCase()) ||
              item.strategy_analyst.toUpperCase().includes(this.search.toUpperCase()) ||
              item.partner_name.toUpperCase().includes(this.search.toUpperCase())
            );
          })
        : this.authorizations;
    },
  },

  methods: {
    openDetailsModal(aut_id) {
      this.detailsId = aut_id;
      this.detailsModalIsActive = true;
    },

    getAuthorizations() {
      this.$api
        .get(this.$endpoint.GET_AUTH_LIST, {
          params: {
            account_id: this.getSelectedAccount.account_id,
          },
        })
        .then((res) => {
          // console.log(res);
          this.authorizations = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getData() {
      if (this.getSelectedAccount.account_id) {
        this.getAuthorizations();
      } else {
        setTimeout(this.getData, 1000);
      }
    },
  },

  mounted() {
    event_bus.$on("CHANGE_ACCOUNT", () => {
      this.getAuthorizations();
    });
    this.getAuthorizations();
  },
};
</script>
